import React from 'react';
import { Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';
// import {
//   faInstagram,
//   faFacebookF
// } from '@fortawesome/free-brands-svg-icons';
//
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const AppFooter = () => {
  const { t } = useTranslation();

  return (
    <div className="app-footer">
      <div className="app-footer__inner">
        <Container>
          <div className="app-footer-left">
            <a rel="noopener noreferrer" target="_blank" href={t('footer.termsUrl')}>
              {t('footer.terms')}
            </a>
            {'\u00a0|\u00a0'}
            <a rel="noopener noreferrer" target="_blank" href={t('footer.privacyUrl')}>
              {t('footer.privacy')}
            </a>
            {'\u00a0|\u00a0'}
            <a rel="noopener noreferrer" target="_blank" href={t('footer.legalUrl')}>
              {t('footer.legal')}
            </a>
            {/*
              <a rel="noopener noreferrer" target="_blank" href="https://iqest.com/use-of-cookies">
                {t('footer.cookies')}
              </a>*/}
          </div>
          <div className="app-footer-center">
            {/*
                          <span><FontAwesomeIcon icon={faInstagram} /></span>
                          <span><FontAwesomeIcon icon={faFacebookF} /></span>
                        */}
          </div>
          <div className="app-footer-right">{t('footer.copyright')}</div>
        </Container>
      </div>
    </div>
  );
};

export default AppFooter;
